<div class="about-section">
    <div class="container">
        <div class="row align-items-center m-1">
            <!-- Left Side: Text -->
            <div class="col-md-7 col-12 about-text">
                <h2>The Dramatics Program</h2>
                <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
                <p>
                    The Dramatics Program at Innovative Vision is a dynamic and imaginative platform designed to help
                    children discover their voice, build confidence, and express their creativity. Through engaging
                    role-play, storytelling, and performance, we provide a safe and supportive environment where
                    children can explore emotions, develop communication skills, and bring characters to life. It's a
                    key component of our holistic approach, nurturing the mind, body, and soul.
                </p>
            </div>
            <!-- Right Side: Image -->
            <div class="col-md-5 col-12 text-center about-img">
                <img src="assets/ivimg/programDetails/dramaticsH.svg" alt="Girl Learning Pottery" class="img-fluid">
            </div>
        </div>
    </div>
</div>
<div class="key-focus-section m-3">
    <div class="image-container">
        <img src="assets/ivimg/programDetails/dramaticsF.svg" alt="Key Focus Areas"/>
    </div>
    <div class="content">
        <h2 class="section-title">Key Focus Areas</h2>
        <div class="points">
            <p>
                <strong>1. Confidence & Communication:</strong> Dramatics is a powerful tool for overcoming shyness and
                building self-assurance. Children learn to project their voices, articulate their thoughts, and perform
                in front of others, which significantly boosts their confidence and communication skills.
            </p>
            <p>
                <strong>2. Creativity & Imagination:</strong> The program encourages children to step into new worlds
                and embody different characters, fostering their creativity, intuition, and imaginative thinking. This
                play-based approach is crucial for right-brain development.
            </p>
            <p>
                <strong>3. Emotional Intelligence & Empathy:</strong> By stepping into the shoes of different
                characters, children learn to understand and express a range of emotions. This practice helps them
                develop emotional intelligence and empathy, essential skills for building strong social connections.
            </p>
        </div>
    </div>
</div>


<div class="program-highlights">
    <div class="highlight-container">
        <!-- Image from assets -->
        <div class="image-container">
            <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
        </div>



        <!-- Text Content -->
        <div class="text-container">
            <h2 class="title">Program Highlights</h2>
            <p>
                <strong>Play-Based Approach:</strong> Our sessions are filled with fun games, improvisational exercises,
                and creative storytelling that make learning dramatics an exciting and engaging experience for all
                children.
            </p>
            <p>
                <strong>Skill Development::</strong> The curriculum is structured to progressively build skills such as
                voice modulation, body language, and stage presence.
            </p>
            <p>
                <strong>Supportive Environment:</strong> We create a non-competitive atmosphere where every child is
                encouraged to participate and express themselves freely, without fear of judgment.
            </p>
        </div>
    </div>
</div>


<div class="benefits-section">
    <h2 class="benefits-title">Benefits for Your Child</h2>
    <p class="benefits-text">
        Our dramatics program offers a wide range of benefits that extend far beyond the stage. It empowers children to
        become better communicators and more confident individuals, while also enhancing their creativity and emotional
        intelligence. The program provides a positive outlet for self-expression and helps children develop a deep sense
        of empathy for others. By nurturing these essential life skills, we help your child grow into a well-rounded and
        expressive individual, ready to take on the world.
    </p>
</div>